<template>
  <div class="level-step-container">
    <KeyStyle
      class="key-style"
      ref="TextArea"
      v-if="mode === 'simple'"
      :input-str="inputStr || defaultStr"
      :dialog-img="levelInfo && levelInfo.ext.img"
    ></KeyStyle>
    <LineStyle
      class="line-style"
      ref="LineTextArea"
      v-if="mode === 'article'"
      :list-word-data="inputStr || defaultStr"
      :dialog-img="levelInfo && levelInfo.ext.img"
    ></LineStyle>
    <SentenceStyle
      class="sentence-style"
      ref="SentenceTextArea"
      v-if="mode === 'words'"
      :list-word-data="inputStr || funnyStr"
      :dialog-img="levelInfo && levelInfo.ext.img"
    ></SentenceStyle>
    <ShotStyle
      class="shot-style"
      ref="ShotTextArea"
      v-if="mode === 'single'"
      :list-word-data="inputStr || fruitStr"
      :dialog-img="levelInfo && levelInfo.ext.img"
    ></ShotStyle>
    <!-- <input
      :value="input"
      class="input"
      @input="onInputChange"
      placeholder="Tap on the virtual keyboard to start"
    > -->
    <div class="space"></div>
    <SimpleKeyboard
      ref="Keyboard"
      @onChange="onChange"
      @onKeyPress="onKeyPress"
      :input="input"
      :next-input="nextKey"
      :dialog-img="levelInfo && levelInfo.ext.img"
    />
  </div>
</template>

<script>
import SimpleKeyboard from "../../SimpleKeyboard";
import KeyStyle from "../../StyleText/KeyStyle";
import LineStyle from "../../StyleText/LineStyle";
import SentenceStyle from "../../StyleText/SentenceStyle";
import ShotStyle from "../../StyleText/ShotStyle";
import { getLevelMessage } from "@http/index";
export default {
  name: "LevelStep",
  components: {
    SimpleKeyboard,
    KeyStyle,
    LineStyle,
    SentenceStyle,
    ShotStyle,
  },
  computed: {
    level() {
      return this.$store.getters.level;
    },
    currentIndex() {
      return this.$store.getters.currentIndex;
    },
    nextIndex() {
      return this.$store.getters.nextIndex;
    },
    levelTotal() {
      return this.$store.getters.levelTotal;
    },
  },
  watch: {
    $route(val) {
      if (this.currentIndex === this.levelTotal) {
        return;
      }
      this.$store.commit("SET_CURRENTINDEX", val.params.step * 1);
      this.fetchLevelMessage();
    },
  },
  data: () => ({
    mode: "simple", // simple=>article>words>single
    input: "",
    nextKey: "",
    funnyStr:
      "Hello World Python C++ Words Excel PPT Javascript Letter Fuck Shift Ctrl",
    inputStr: "",
    fruitStr: "Javscript",
    defaultStr: "HelloXES", // 输入字符串
    levelInfo: null,
  }),
  async created() {
    this.fetchLevelMessage();
  },
  async mounted() {
    this.$refs.Keyboard.compare = (btn) => {
      console.log("当前的", btn);
      if (btn === false) {
        return true;
      }
      var ch = "";
      switch (this.mode) {
        case "simple":
          ch = this.$refs.TextArea.nextWord();
          this.nextKey = this.$refs.TextArea.nextKey();
          this.$refs.TextArea.removeKey(btn);
          break;
        case "article":
          ch = this.$refs.LineTextArea.nextWord();
          this.nextKey = this.$refs.LineTextArea.nextKey();
          this.$refs.LineTextArea.handlerWord(btn);
          break;
        case "words":
          this.$refs.SentenceTextArea.handlerWord();
          ch = this.$refs.SentenceTextArea.nextWord();
          this.nextKey = this.$refs.SentenceTextArea.nextKey();
          break;
        case "single":
          this.$refs.ShotTextArea.handlerWord(btn);
          ch = this.$refs.SentenceTextArea.nextWord();
          this.nextKey = this.$refs.SentenceTextArea.nextWord();
          break;
        default:
          ch = this.$refs.TextArea.nextWord();
          this.nextKey = this.$refs.TextArea.nextKey();
          this.$refs.TextArea.removeKey(btn);
          break;
      }
      return ch === btn;
    };
  },
  methods: {
    async fetchLevelMessage() {
      let res = await getLevelMessage({
        level: this.$route.params.step,
        type: this.$route.query.type,
      });
      this.levelInfo = res;
      this.$store.commit("SET_LEVELTOTAL", res.total);
      this.input = "";
      this.mode = res.mode;
      this.inputStr = res.mission || this.defaultStr;
      // this.inputStr = "123"
    },
    onChange(input) {
      this.input = input;
    },
    onKeyPress(button) {
      window.console.log("button", button);
    },
    onInputChange(input) {
      this.input = input.target.value;
    },
  },
};
</script>

<style lang="less" scoped></style>
